// import React, { useRef } from "react";
// import { Box, Grid, Paper, FormControl, InputLabel, Select, MenuItem, OutlinedInput, TextField, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, ClickAwayListener, Card, CardContent, Typography, useMediaQuery, useTheme, Button } from "@mui/material";
// import AddIcon from "@mui/icons-material/Add";

// export default function SearchSection({ searchOptions, normalDropdownValue, onSearchByChange, searchText, onSearchTextChange, showResults, searchResults, onSelectResult, onNewToggle, onCloseResults , openClientPopUp }) {
//   const inputRef = useRef();
//   const theme = useTheme();
//   const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

//   const handleResultClick = (result) => {
//     console.log('SearchSection: Clicking result:', JSON.stringify(result, null, 2)); // Debug log
//     onSelectResult(result);
//     onCloseResults(); // Close results after selection
//   };

//   console.log("normalDropdownValue" , normalDropdownValue)

//   return (
//     <Grid sx={{ bgcolor: "grey.50", width: "100%", mx: "auto", mt: 1.5,mb:1.8, p: 1, borderRadius: 1, overflow: "visible", border: "1px solid", borderColor: "grey.300" }}>
//       <Grid container spacing={1} alignItems="center">
//         {/* Search-by */}
//         <Grid item size={{xs:12 , md:3}}>
//           <FormControl fullWidth size="small"  sx={{
//                                     '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}>
//             <InputLabel id="search-by-label">Search By</InputLabel>
//             <Select
//               labelId="search-by-label"
//               value={normalDropdownValue || ""}
//               label="Search By"
//               onChange={(e) => onSearchByChange(e.target.value)}
//               input={<OutlinedInput label="Search By" />}
              
//             >
//               {searchOptions.map((opt) => (
//                 <MenuItem key={opt.value} value={opt.value}>
//                   {opt.label}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </Grid>

//         {/* Input + “New?” */}
//         <Grid item size={{xs:12 , md:7}} sx={{ position: "relative" }}>
//           <ClickAwayListener onClickAway={() => setTimeout(onCloseResults, 200)}>
//             <Box>
//               <TextField
//                sx={{
//                                     '& .MuiOutlinedInput-root': { height: 38, display: 'flex', alignItems: 'center' },
//                                     '& .MuiOutlinedInput-input': { fontSize: '0.875rem', padding: '0 12px' }
//                                 }}
//                 fullWidth
//                 size="small"
//                 placeholder="Type to search…"
//                 value={searchText}
//                 // onChange={(e) => {
//                 //   console.log('SearchSection: Search text changed:', e.target.value); // Debug log
//                 //   onSearchTextChange(e.target.value);
//                 // }}
//                  onChange={(e) => {
//                   let newValue = e.target.value;
                  
//                   // If searching by GST No, limit to 15 characters
//                   if (normalDropdownValue === "GSTNo" && newValue.length > 15) {
//                     newValue = newValue.slice(0, 15);
//                   }
                  
//                   console.log('SearchSection: Search text changed:', newValue); // Debug log
//                   onSearchTextChange(newValue);
//                 }}
//                  inputProps={{
//                   maxLength: normalDropdownValue === "GSTNo" ? 15 : undefined,
//                 }}
//                 inputRef={inputRef}
//                 // Removed onBlur to prevent premature closure
//               />
//               {showResults && searchText.trim() && (
//                <Paper
//     elevation={0}
//     sx={{
//       mt: 1,
//       position: "absolute",
//       width: { xs: "100%", md: "800px" },
//       zIndex: 1200,
//       border: "1px solid rgba(0,0,0,0.2)",
//       borderRadius: 1,
//       maxHeight: 260,
//       overflowY: "auto",
//       left: { xs: 0, md: "50%" },
//       transform: { md: "translateX(-50%)" }
//     }}
//   >
//                   {isDesktop ? (
// //                     <TableContainer>
// //                       <Table size="small">
// //                         <TableHead>
// //                           <TableRow>
// //                             <TableCell>Company</TableCell>
// //                             <TableCell>GST No</TableCell>
// //                             <TableCell>Contact</TableCell>
// //                             <TableCell>Mobile</TableCell>
// //                             <TableCell>City</TableCell>
// //                           </TableRow>
// //                         </TableHead>
// //                         <TableBody>
// //                           {searchResults.length > 0 ? (
// //                             searchResults.map((r, i) => (
// //                               <TableRow
// //                                 key={r.id || i} // Use r.id for unique key
// //                                 hover
// //                                 sx={{ cursor: "pointer" }}
// //                                 onClick={() => handleResultClick(r)}
// //                               >
// //                                 <TableCell sx={{ fontSize: { xs: "0.875rem", md: "0.8rem" } }}>{r.FirmName}</TableCell>
// //                                 <TableCell sx={{ fontSize: { xs: "0.875rem", md: "0.8rem" } }}>{r.GSTNo}</TableCell>
// //                                 <TableCell sx={{ fontSize: { xs: "0.875rem", md: "0.8rem" } }}>{r.ContactPerson}</TableCell>
// //                                 <TableCell sx={{ fontSize: { xs: "0.875rem", md: "0.8rem" } }}>{r.MobileNo}</TableCell>
// //                                 <TableCell sx={{ fontSize: { xs: "0.875rem", md: "0.8rem" } }}>{r.City}</TableCell>
// //                               </TableRow>
// //                             ))
// //                           ) : (
// //                            <TableRow>
// //   <TableCell colSpan={5} align="center">
// //     <Typography sx={{ mb: 1 }}>
// //       No Data Available
// //     </Typography>

// //     <Button
// //       variant="contained"
// //       color="primary"
// //       startIcon={<AddIcon />}
// //       size="small"
// //       onMouseDown={openClientPopUp}   // 🔥 IMPORTANT
// //     >
// //       Add New Client
// //     </Button>
// //   </TableCell>
// // </TableRow>

// //                           )}
// //                         </TableBody>
// //                       </Table>
// //                     </TableContainer>
//                     <Table size="small" stickyHeader>
//         <TableHead>
//           <TableRow>
//             {["Company", "GST No", "Contact", "Mobile", "City"].map(h => (
//               <TableCell
//                 key={h}
//                 sx={{
//                   backgroundColor: "#E0E0E0",
//                   fontWeight: 600,
//                   fontSize: "0.75rem",
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 1
//                 }}
//               >
//                 {h}
//               </TableCell>
//             ))}
//           </TableRow>
//         </TableHead>

//         <TableBody>
//           {searchResults.length > 0 ? (
//             searchResults.map((r, i) => (
//               <TableRow
//                 key={r.id || i}
//                 hover
//                 sx={{ cursor: "pointer" }}
//                 onMouseDown={() => handleResultClick(r)}
//               >
//                 <TableCell>{r.FirmName}</TableCell>
//                 <TableCell>{r.GSTNo || "-"}</TableCell>
//                 <TableCell>{r.ContactPerson || "-"}</TableCell>
//                 <TableCell>{r.MobileNo || "-"}</TableCell>
//                 <TableCell>{r.City || "-"}</TableCell>
//               </TableRow>
//             ))
//           ) : (
//            <TableRow>
//   <TableCell colSpan={5} align="center">
//    <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//             Client not found
//           </Box>
//      <Box
//               sx={{
//                 position: 'sticky',
//                 bottom: 0,
//                 backgroundColor: '#fff',
//                 textAlign: 'center',
//                 p: 1,
//                 fontWeight: 600,
//                 color: 'primary.main',
//                 cursor: 'pointer',
//               }}
//                onMouseDown={openClientPopUp}
//             >
//               ➕ Add New Client
//             </Box>
//   </TableCell>
// </TableRow>

//           )}
//         </TableBody>
//       </Table>
//                   ) : (
//                     <Box sx={{ p: 1 }}>
//                       {searchResults.length > 0 ? (
//                         searchResults.map((r, i) => (
//                           <Card
//                             key={r.id || i} // Use r.id for unique key
//                             variant="outlined"
//                             sx={{ mb: 1, cursor: "pointer" }}
//                             onClick={() => handleResultClick(r)}
//                           >
//                             <CardContent>
//                               <Typography variant="subtitle1">{r.FirmName}</Typography>
//                               <Grid container spacing={1}>
//                                 <Grid item xs={6}>
//                                   <Typography variant="body2">
//                                     <strong>GST:</strong> {r.GSTNo}
//                                   </Typography>
//                                   <Typography variant="body2">
//                                     <strong>Contact:</strong> {r.ContactPerson}
//                                   </Typography>
//                                 </Grid>
//                                 <Grid item xs={6}>
//                                   <Typography variant="body2">
//                                     <strong>Mobile:</strong> {r.MobileNo}
//                                   </Typography>
//                                   <Typography variant="body2">
//                                     <strong>City:</strong> {r.City}
//                                   </Typography>
//                                 </Grid>
//                               </Grid>
//                             </CardContent>
//                           </Card>
//                         ))
//                       ) : (
//                         <>
//                          <Box sx={{ p: 2, textAlign: 'center', color: 'error.main' }}>
//             Client not found
//           </Box>
//      <Box
//               sx={{
//                 position: 'sticky',
//                 bottom: 0,
//                 backgroundColor: '#fff',
//                 textAlign: 'center',
//                 p: 1,
//                 fontWeight: 600,
//                 color: 'primary.main',
//                 cursor: 'pointer',
//               }}
//                onMouseDown={openClientPopUp}
//             >
//               ➕ Add New Client
//             </Box>
//                         </>
//                       )}
//                     </Box>
//                   )}
//                 </Paper>
//               )}
//             </Box>
//           </ClickAwayListener>
//         </Grid>
//       </Grid>
//     </Grid>
//   );
// }


import { colors as themeColors } from '../utils/theme';
import React, { useRef } from "react";
import {
  Box,
  Grid,
  Paper,
  TextField,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  ClickAwayListener,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export default function SearchSection({
  searchText,
  onSearchTextChange,
  showResults,
  searchResults,
  onSelectResult,
  onNewToggle,
  onCloseResults,
  openClientPopUp
}) {
  const inputRef = useRef();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const handleResultClick = (result) => {
    onSelectResult(result);
    onCloseResults();
  };

  return (
  
      <Grid container spacing={1} alignItems="center" sx={{ mt: 1.5,
        mb:2.2, width:"80%"}}>
        {/* Only Search Input */}
        <Grid item size={{xs:12, md:12}} sx={{ position: "relative" }}>
          <ClickAwayListener onClickAway={() => setTimeout(onCloseResults, 200)}>
            <Box>
              <TextField
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: 38,
                    display: "flex",
                    alignItems: "center"
                  },
                  "& .MuiOutlinedInput-input": {
                    fontSize: "0.875rem",
                    padding: "0 12px"
                  }
                }}
                fullWidth
                size="small"
                placeholder="Type to search…"
                value={searchText}
                onChange={(e) => onSearchTextChange(e.target.value)}
                inputRef={inputRef}
              />

              {showResults && searchText.trim() && (
                <Paper
                  elevation={0}
                  sx={{
                    mt: 1,
                    position: "absolute",
                    width: { xs: "100%"},
                    zIndex: 1200,
                    border: "1px solid rgba(0,0,0,0.2)",
                    borderRadius: 1,
                    maxHeight: 260,
                    overflowY: "auto",
                    left: { xs: 0, md: "50%" },
                    transform: { md: "translateX(-50%)" }
                  }}
                >
                  {isDesktop ? (
                    <Table size="small" stickyHeader>
                      <TableHead>
                        <TableRow>
                          {["Company", "GST No", "Contact", "Mobile", "City"].map((h) => (
                            <TableCell
                              key={h}
                              sx={{
                                backgroundColor: themeColors.neutral.line,
                                fontWeight: 600,
                                fontSize: "0.75rem",
                                position: "sticky",
                                top: 0,
                                zIndex: 1
                              }}
                            >
                              {h}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {searchResults.length > 0 ? (
                          searchResults.map((r, i) => (
                            <TableRow
                              key={r.id || i}
                              hover
                              sx={{ cursor: "pointer" }}
                              onMouseDown={() => handleResultClick(r)}
                            >
                              <TableCell>{r.FirmName}</TableCell>
                              <TableCell>{r.GSTNo || "-"}</TableCell>
                              <TableCell>{r.ContactPerson || "-"}</TableCell>
                              <TableCell>{r.MobileNo || "-"}</TableCell>
                              <TableCell>{r.City || "-"}</TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <Box sx={{ p: 2, textAlign: "center", color: "error.main" }}>
                                Client not found
                              </Box>
                              <Box
                                sx={{
                                  position: "sticky",
                                  bottom: 0,
                                  backgroundColor: themeColors.neutral.surface,
                                  textAlign: "center",
                                  p: 1,
                                  fontWeight: 600,
                                  color: "primary.main",
                                  cursor: "pointer"
                                }}
                                onMouseDown={openClientPopUp}
                              >
                                ➕ Add New Client
                              </Box>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  ) : (
                    <Box sx={{ p: 1 }}>
                      {searchResults.length > 0 ? (
                        searchResults.map((r, i) => (
                          <Card
                            key={r.id || i}
                            variant="outlined"
                            sx={{ mb: 1, cursor: "pointer" }}
                            onClick={() => handleResultClick(r)}
                          >
                            <CardContent>
                              <Typography variant="subtitle1">{r.FirmName}</Typography>
                              <Grid container spacing={1}>
                                <Grid item xs={6}>
                                  <Typography variant="body2">
                                    <strong>GST:</strong> {r.GSTNo}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>Contact:</strong> {r.ContactPerson}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6}>
                                  <Typography variant="body2">
                                    <strong>Mobile:</strong> {r.MobileNo}
                                  </Typography>
                                  <Typography variant="body2">
                                    <strong>City:</strong> {r.City}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </CardContent>
                          </Card>
                        ))
                      ) : (
                        <>
                          <Box sx={{ p: 2, textAlign: "center", color: "error.main" }}>
                            Client not found
                          </Box>
                          <Box
                            sx={{
                              position: "sticky",
                              bottom: 0,
                              backgroundColor: themeColors.neutral.surface,
                              textAlign: "center",
                              p: 1,
                              fontWeight: 600,
                              color: "primary.main",
                              cursor: "pointer"
                            }}
                            onMouseDown={openClientPopUp}
                          >
                            ➕ Add New Client
                          </Box>
                        </>
                      )}
                    </Box>
                  )}
                </Paper>
              )}
            </Box>
          </ClickAwayListener>
        </Grid>
      </Grid>

  );
}
